module.exports = __webpack_public_path__ + "static/img/14000365.4dd2c5b8.png";